import { southElevationSvg } from '../elevations/southElevationSvg';
import { eastElevationSvg } from '../elevations/eastElevationSvg';
import { northElevationSvg } from '../elevations/northElevationSvg';
import { westElevationSvg } from '../elevations/westElevationSvg';

export default function elevations(prefix) {
  switch (prefix) {
    case 'n':
      return northElevationSvg;
    case 'e':
      return eastElevationSvg;
    case 's':
      return southElevationSvg;
    case 'w':
      return westElevationSvg;
    default:
      console.log('Prefix missing');
  }
}
